import * as React from "react";
import {ReactElement} from "react";
import { connect } from "react-redux";
import {Box, styled, Typography} from "@mui/material";
import { IPageProps } from "../interfaces/components/props/IPageProps";
import {RootState} from "../redux/store";

const Root = styled(Box)(({theme}) => ({
	minHeight: '100%',
	height: 'auto',
}));

const TextContainerWrapper = styled(Box)(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	placeContent: 'center',
	height: 400,
}));

const TextContainer = styled(Box)(({theme}) => ({
	width: '100%',
	display: 'grid',
	alignContent: 'center',
	placeItems: 'center',
	textAlign: 'center',
}));

const Header = styled(Typography)(({theme}) => ({
	paddingBottom: theme.spacing(4),
}));

interface IProps extends IPageProps {
}

function LegalNotice(props: IProps): ReactElement {
		const {languageTokens } = props;

		const name = `${languageTokens.firstName} ${languageTokens.secondName}`;

		return (
			<Root id={'LegalNotice'}>
				<TextContainerWrapper>
					<TextContainer>
						<Header
							variant={"h2"}
						>{languageTokens.LegalNotice}
						</Header>
						<Typography variant={"subtitle1"}>{name} ({languageTokens.myCity})</Typography>
						{languageTokens.companyName.length == 0 ?
							null : <Typography variant={"subtitle1"}>{languageTokens.companyName}</Typography>
						}
						<br/>
						<br/>
						{languageTokens.addressLine1.length == 0 ?
							null : <Typography variant={"subtitle1"}>{languageTokens.addressLine1}</Typography>
						}
						{languageTokens.addressLine2.length == 0 ?
							null : <Typography variant={"subtitle1"}>{languageTokens.addressLine2}</Typography>
						}
						{languageTokens.addressLine3.length == 0 ?
							null : <Typography variant={"subtitle1"}>{languageTokens.addressLine3}</Typography>
						}
						{languageTokens.addressLine4.length == 0 ?
							null : <Typography variant={"subtitle1"}>{languageTokens.addressLine4}</Typography>
						}
					</TextContainer>
				</TextContainerWrapper>
			</Root>
		);
	}

const mapStateToProps = (state: RootState) => ({
	languageTokens: state.language.languageTokens,
});

const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(LegalNotice);
